import React, { Component } from 'react';
import { Route, Switch, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { getUser, getUserList } from "../../requests/UserRequests";
import { getRegistrationRequestById, getRegistrationRequests } from "../../requests/RegistrationRequests";
import ResetPassword from "../resetpassword/ResetPassword";
import AccountPaymentPage from "../payment-methods/AccountPaymentPage";
import ListUsersPage from "../user-management/ListUsersPage";
import ManageUserPage from "../user-management/ManageUserPage";
import RegistrationRequestsPage from "./registration-requests/RegistrationRequestsPage";
import EditConfiguration from './configuration/EditConfiguration';
import { getAccountTypes, getPrimaryAccountTypes } from "../../requests/AccountTypeRequests";
import {updateAccountTypes, updatePrimaryAccountTypes} from "../../actions/InvoiceActions";
import {
  canEditSystemConfig, canManagePaymentMethods,
  canManageRegistrationRequests,
  canManageUsers,
  canViewUsers
} from "../../PermissionSelectors";

class SettingsPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  componentDidMount() {
    getAccountTypes().then((accountTypes) => {
      updateAccountTypes(this.props.dispatch, accountTypes);
    });

    getPrimaryAccountTypes().then((accountTypes) => {
      updatePrimaryAccountTypes(this.props.dispatch, accountTypes);
    });
  }

  navBarToggleClick = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    let collapsedClass = `${'collapse navbar-collapse webar-navbar-collapse'}`;

    if (!this.state.collapsed) {
      collapsedClass = 'navbar-collapse webar-navbar-collapse';
    }
    return <div className={"settings-content"}>
      <nav className="settings-sub-header webar-navbar navbar fixed-top navbar-expand-lg navbar-light nav-color d-none d-lg-block">
        <div className="container">
          <button className="navbar-toggler" type="button" onClick={this.navBarToggleClick}>
            <span className="navbar-toggler-icon" />
          </button>
          <div className={collapsedClass} id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <NavLink exact to={"/settings/profile"} className="nav-link">Account</NavLink>
              </li>
              {(this.props.canViewUsers) ?
                <li className="nav-item">
                  <NavLink exact to={"/settings/users"} className="nav-link">User Management</NavLink>
                </li> : null
              }
              {/* TODO SCHINDLER SPECIFIC */}
              {/*{(this.props.canManageRegistrationRequests) ?*/}
                {/*<li className="nav-item">*/}
                  {/*<NavLink exact to={"/settings/registration-requests"} className="nav-link">Registration Requests</NavLink>*/}
                {/*</li> : null*/}
              {/*}*/}
              {this.props.canEditSystemConfig ?
                <li className="nav-item">
                  <NavLink exact to={"/settings/configuration"} className="nav-link">Configuration</NavLink>
                </li> : null
              }
              {this.props.canManagePaymentMethods && <li className="nav-item">
                <NavLink to={"/settings/payment-methods"} className="nav-link">Payment Methods</NavLink>
              </li>}
            </ul>
          </div>
        </div>
      </nav>
      <div className={"settings-page"}>
        <Switch>
          {/* Order matters here! */}
          {this.props.canManageUsers && <Route path="/settings/users/add/:request?" render={(props) => <ManageUserPage
            fromRequest={props.match.params.request} getRegistrationRequest={getRegistrationRequestById}/>}/>}
          {this.props.canManageUsers && <Route path="/settings/users/:userId"
                                               render={(props) => <ManageUserPage
                                                 getUser={getUser(props.match.params.userId)}/>}/>}
          {this.props.canViewUsers &&
          <Route path="/settings/users" render={(props) => <ListUsersPage getUsers={getUserList}/>}/>}
          {this.props.canManageRegistrationRequests && <Route path="/settings/registration-requests"
                                                              render={(props) => <RegistrationRequestsPage
                                                                getRequests={getRegistrationRequests}/>}/>}
          {this.props.canEditSystemConfig && <Route path="/settings/configuration"
                                                    render={(props) => <EditConfiguration/>}/>}
          {this.props.canManagePaymentMethods &&
          <Route path="/settings/payment-methods" component={AccountPaymentPage}/>}
          <Route path={"/settings/profile"} component={ResetPassword}/>
        </Switch>
      </div>
    </div>
  }
}

export default connect((state, props) => ({
  canEditSystemConfig: canEditSystemConfig(state, props),
  canManagePaymentMethods: canManagePaymentMethods(state, props),
  canManageRegistrationRequests: canManageRegistrationRequests(state, props),
  canManageUsers: canManageUsers(state, props),
  canViewUsers: canViewUsers(state, props),
}))(SettingsPage);
